<template>
	<Container>
		<TopBar />
		<div class="content">
			<div class="order-detail">
				<Row style="border: 1px solid rgba(0,0,0,0.05);">
					<Col :lg='8' class='order-left'>
					<p class="order-info">订单信息(Order Information)</p>
					<div style="margin-left: 0.1rem;">
						<Row style="margin-top: 0.1rem;">
							<Col span='10'>订单编号(Order Number):</Col>
							<Col span='14'>{{order.orderId}}</Col>
						</Row>
						<Row style="margin-top: 0.1rem;" v-if='order.originalID'>
							<Col span='10'>订单来源(Order Source):</Col>
							<Col span='14'>{{convertChannel(order.channel)}}</Col>
						</Row>
						<Row style="margin-top: 0.1rem;">
							<Col span='10'>订单类型(Order Type):</Col>
							<Col span='14'>{{order.lrp=='100'?'Standard':'LRP'}}&nbsp;<b v-if='lrptType==11'>Template</b></Col>

						</Row>
						<Row style="margin-top: 0.1rem;">
							<Col span='10'>收货地址(Delivery Address):</Col>
							<Col span='14'>{{address}} <span v-if='canEditAddress' style="color: #BC86C8;text-decoration: underline;cursor: pointer;" @click='changeAddress'>修改地址</span></Col>
						</Row>
						<Row style="margin:0.1rem auto;">
							<Col span='10'>联系电话(TelePhone):</Col>
							<Col span='14'>{{order.telephone}}</Col>
						</Row>

					</div>
					</Col>
					<Col :lg='16' class='track'>
					<h3>物流信息(Logistics Information)</h3>
					<div class="track-detail">
						<p>
							<span v-if='order.carrierName'>{{order.carrierName}}:</span><span v-else-if='deliveryStoreId != "501"'>{{deliveryName}}：</span><span>{{order.shippingNo}}</span>
							<Button class='show-btn' type='text' @click='showTrack=true' v-if='order.expressUrl&&order.expressUrl.indexOf("http")==0'>查看物流详情</Button>
							<div v-if='deliveryStoreId != "501"'>精油生活馆地址：{{shopAddress}}</div>	
						</p>
						<Modal v-model='showTrack' title="物流详情" width='600'>
							<iframe :src="order.expressUrl" class="track-list"></iframe>
						</Modal>

					</div>

					<h3>发票信息(Invoice Information)</h3>
					<div class="track-detail">
						<p v-show="InvoiceLoad">{{InvoiceStatusText}}
							<a class='orderdetail-down' target="_blank" v-show="invoice.InvoiceStatus=='10'" v-on:click="InvoinceDown">下载发票</a>
							<a class='orderdetail-down' target="_blank" v-show="CanCancelInvoice" v-on:click="InvoinceCancel">作废发票</a>
							<Button class='show-btn' type='text' @click='showInvoice=true' v-show='canInvoice'>{{InvoiceStatusBtnText}}</Button>
						</p>
						<p style="font-size: 13px;">请在订单完成后的一个月内申请开具电子发票，如发票开具有误请在开具后的30天内申请发票作废，逾期后已开具的电子发票无法进行任何修改</p>
						<Modal v-model='showInvoice' title="发票详情" width='600' ok-text="提交">
							<table class="Invoice-list">
								<tbody>
									<tr>
										<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>类型:</td>
										<td class="Invoice-content">
											<span v-if="InvoiceStatus==0">
												<RadioGroup v-model="invoice.CompanyTypeText" type="button" size="large">
													<Radio label="个人"></Radio>
													<Radio label="企业"></Radio>
													<Radio label="机关事业单位"></Radio>
												</RadioGroup>
											</span>
											<span v-else>
												{{invoice.CompanyTypeText}}
											</span>
										</td>
										<td class="Invoice-right"></td>
									</tr>
									<tr>
										<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>发票抬头:</td>
										<td class="Invoice-content">
											<span v-if="InvoiceStatus==0 && isPersonal">
												<input type="text" class="ivu-input" v-model="invoice.InvoiceTitle" maxlength="50">
											</span>
											<span v-else>
												{{invoice.InvoiceTitle}}
											</span>
										</td>
										<td></td>
									</tr>
									<tr v-show="InvoiceStatus==0 && isPersonal">
										<td class="Invoice-head"></td>
										<td>
											<Select v-model="invoiceCompany" size="large" @on-change="chooseInvoiceInfo()">
												<Option v-for="(item,index) in invoiceInfo" :value="index" :key="item.Id">{{ item.InvoiceTitle }}</Option>
											</Select>
										</td>
										<td class="Invoice-right">
											<Button type="primary" class="btn-invoiceDelete" @click="deleteInvoiceInfo">删除</Button></td>
									</tr>
									<tr v-show='isPersonal && showTaxPayerId'>
										<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>纳税人识别号:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.TaxPayerId" v-if="InvoiceStatus==0" @blur="invoice.TaxPayerId=invoice.TaxPayerId.toUpperCase()"
											 maxlength="20">
											<!-- 1234567890 -->
											<span v-else>
												{{invoice.TaxPayerId}}
											</span>
										</td>
										<td class="Invoice-right" rowspan="6"></td>
									</tr>
									<tr v-show='isPersonal'>
										<td class="Invoice-head">地址:</td>
										<td class="Invoice-content">
											<!--上海-->
											<input type="text" class="ivu-input" v-model="invoice.Address" v-if="InvoiceStatus==0" maxlength="50">
											<!-- <RadioGroup v-model="invoice.Address" type="button" size="large" v-if="InvoiceStatus==0">
													<Radio label="上海" selected="true"></Radio>
												</RadioGroup> -->
											<span v-else>
												{{invoice.Address}}
											</span>
										</td>
									</tr>
									<tr v-show='isPersonal'>
										<td class="Invoice-head">电话:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.Phone" v-if="InvoiceStatus==0" maxlength="20">
											<!-- 15000000000 -->
											<span v-else>
												{{invoice.Phone}}
											</span>
										</td>
									</tr>
									<tr v-show='isPersonal'>
										<td class="Invoice-head">开户银行:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.BankName" v-if="InvoiceStatus==0" maxlength="20">
											<!-- 招商银行闵行支行 -->
											<span v-else>
												{{invoice.BankName}}
											</span>
										</td>
									</tr>
									<tr v-show='isPersonal'>
										<td class="Invoice-head">银行账号:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.BankNo" v-if="InvoiceStatus==0" maxlength="20">
											<!-- 60000000000000 -->
											<span v-else>
												{{invoice.BankNo}}
											</span>
										</td>
									</tr>
									<!-- <tr v-show='isPersonal'>
										<td class="Invoice-head">邮箱:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.Email" v-if="InvoiceStatus==0" maxlength="20">
											<span v-else>
												{{invoice.Email}}
											</span>
										</td>
									</tr> -->
								</tbody>
							</table>
							<div slot="footer">
								<Button type="text" v-show="InvoiceStatus==0" v-on:click="cancelInvoice()">取消</Button>
								<Button type="primary" v-on:click="submitInvoice()">确定</Button>
							</div>
						</Modal>
						<Modal v-model='showInvoiceLink' title="发票文件" width='600'>
							您的发票文件已生成，点击确认后开始下载或者输入邮箱地址，我们将通过邮件发送给您。<br>
							<input type="text" class="ivu-input" v-model="InvoiceEmail" maxlength="50" placeholder="邮箱地址">
							<div slot="footer">
								<Button type="text" v-on:click="cancelInvoiceLink()">取消</Button>
								<a v-bind:href="pdfUrl" target="_blank" class="orderdetail-downLink ivu-btn ivu-btn-primary">下载</a>
								<Button type="text" v-on:click="PostInvoiceEmail()" class="ivu-btn ivu-btn-primary">发送邮件</Button>
							</div>
						</Modal>
						<Modal v-model='confirmInvoice' title="信息" width='600' ok-text="确认" @on-ok="postInvoice">
							请再次确认纳税人识别号是否正确
						</Modal>
					</div>
					</Col>
				</Row>
				<Table class='products' stripe :columns="columns" :data="order.Details"></Table>
				<Row style="background-color: #f3f3f3;margin-top: 0.5rem;">
					<Col :lg='{span:9, push:15}' class="fee">
					<Row>
						<Col :lg='12' :xs='18'>回馈点数兑换(PT):</Col>
						<Col :lg='12' :xs='6'>{{order.totalPoint||'0'}}</Col>
						<Col :lg='12' :xs='18'>订单金额/PV (Order Amount/PV):</Col>
						<Col :lg='12' :xs='6'>￥{{order.total}}&nbsp;/&nbsp;{{order.PV||'0'}}</Col>
						<Col :lg='12' :xs='18'>其他费用 (Other Expenses):</Col>
						<Col :lg='12' :xs='6'>￥{{order.feeTotal}}</Col>
						<Col :lg='12' :xs='18'>订单总计 (Order Total):</Col>
						<Col :lg='12' :xs='6'>￥{{order.grandTotal}}</Col>
						<Col :lg='12' :xs='18' style='color:orange'>产品积分 (Product Credits):</Col>
						<Col :lg='12' :xs='6' style='color:orange'>{{order.totalAr}}</Col>
						<Col :lg='12' :xs='18' style='font-weight: bold;font-size: 14px;'> 支付金额 (Payment Amount):</Col>
						<Col :lg='12' :xs='6' style='font-weight: bold;font-size: 14px;'>￥{{ actualPay || '0'}}</Col>
					</Row>
					</Col>
				</Row>
			</div>
		</div>
		<editAddressView title='修改收货人' :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='addressLoading'></editAddressView>
	</Container>

</template>

<script>
	import TopBar from "@/components/common/TopBar";
	import editAddressView from "@/components/order/editAddressView";
	import {RE_EMAIL} from '@/components/common/regex';
	import util from '@/config/util';
	import {
		mapState,
		mapActions,
		mapMutations,
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				columns: [
					{
						key: 'name',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, '商品'), h('div', null, 'Commodity')])
						}
					},
					{
						key: 'price',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, '单价'), h('div', null, 'Unit Price')])
						}
					},
					{
						key: 'PV',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, 'PV')])
						}
					},
					{
						key: 'qty',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, '数量'), h('div', null, 'quantity')])
						}
					},
					{
						key: 'subTotal',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, '金额小计'), h('div', null, 'SubTotal')])
						}
					},
				],

				order: {},
				from: 'orders',
				showTrack: false,
				showInvoice: false,
				invoice:
				{
					TaxPayerId: '',
					InvoiceTitle: '个人',
					CompanyTypeText: '个人',
					CompanyType: '03',
					Address: '上海',
					Phone: '',
					BankName: '',
					BankNo: '',
					Email: '',
					InvoiceStatus: '0'
				},
				invoiceInfo: {},
				invoiceCompany: '',
				InvoiceStatusBtnText: '申请开具发票',
				InvoiceLoad: false,
				loading: true,
				canInvoice: true,
				CanCancelInvoice:false,
				pdfUrl: '',
				showInvoiceLink: false,
				confirmInvoice: false,
				lrptType: 0,
				deliveryStoreId:'501',
				delivery:{},
				shopAddress:'',
				deliveryName:null,
				showTaxPayerId:true,
				InvoiceEmail:'',
				editAddress:{
                    id:0,
                    name:null,
                    province_id:null,
                    moblie_phone:null,
                    city_id:null,
                    county_id:null,
                    town_id:null,
                    street:null,
                    zip :null,
                    is_default:'0',
                    tag_type:'0',
                    address_type:'1',
                },
                show:false,
                addressLoading:false,

			}
		},
		components: {
			TopBar,
			editAddressView,
		},
		created() {
			this.$nextTick(function () {
				this.initData()
			});
		},
		computed: {
			...mapState({
				userInfo: state => state.common.wechatUserInfo,
			}),
			address() {
				let order = this.order
				if (this.delivery.ProvinceName) {
					return `${this.delivery.ProvinceName} ${this.delivery.CityName} ${this.delivery.CountyName} ${this.delivery.TownName||''} ${this.delivery.Street}`;
				}
				if (order.region) {
					return `${order.region} ${order.city} ${order.district} ${order.TownName||''} ${order.street}`;
				}
				return ''
			},
			actualPay() {
				let actualPay = parseFloat(this.order.grandTotal) - parseFloat(this.order.totalAr);
				return actualPay.toFixed(2);
			},
			canEditAddress(){
				let editable = true
				if (this.deliveryStoreId != '501') return false
				if(this.order.createTime){
					let now = new Date()
					let payTime = util.formatDate.dateFromStr(this.order.createTime)
					if (now - payTime > 1800000)  {
						return false
					}
				} else {
					return false
				}
				let channel = (this.order.channel || '').toLowerCase()
				if (!(['myo','wechat','moblieapp'].includes(channel))) return false
				if (this.order.orderStatus != 20) return false
				return editable
			},
			CompanyTypeText() {
				//01：企业  02：机关事业单位 03：个人  04：其它
				if (this.invoice.CompanyType == '01') {
					return '企业'
				}
				else if (this.invoice.CompanyType == '02') {
					return '机关事业单位'
				}
				else if (this.invoice.CompanyType == '03') {
					return '个人'
				}
				else if (this.invoice.CompanyType == '04') {
					return '其他'
				}
				return '个人'
			},
			CompanyType() {
				//01：企业  02：机关事业单位 03：个人  04：其它
				if (this.invoice.CompanyTypeText == '企业') {
					return '01'
				}
				else if (this.invoice.CompanyTypeText == '机关事业单位') {
					return '02'
				}
				else if (this.invoice.CompanyTypeText == '个人') {
					return '03'
				}
				else if (this.invoice.CompanyTypeText == '其他') {
					return '04'
				}
				return '03'
			},
			InvoiceStatus() {
				if (this.invoice.InvoiceStatus == "00" || this.invoice.InvoiceStatus == "10") {
					return 1;//发票开具中\已开具发票，直接显示发票信息，不能再次申请
				}
				else {
					return 0;
				}
			},
			InvoiceStatusText() {
				if (this.invoice.InvoiceStatus == "00") {
					return "发票开具中"
				}
				else if (this.invoice.InvoiceStatus == "10") {
					return "已开具发票"
				}
				else if (this.invoice.InvoiceStatus == "-1") {
					return "开票失败"//开票失败，显示上次开票信息，可以再次申请
				}
				else{
					return "未开具发票";
				}
			},
			isPersonal() {
				if (this.invoice.CompanyType == '03') {
					return false;
				}
				else {
					return true;
				}
			}
		},
		watch: {
			'invoice.CompanyTypeText'(value) {
				console.log('类型修改')
				console.log(value)
				this.invoice.CompanyType=this.CompanyType;
				if (this.InvoiceStatus == 0) {
					if (value == '个人') {
						this.invoice.InvoiceTitle = '个人';
						this.showTaxPayerId=true;
					}
					else if (value == '企业') {
						if (this.invoice.InvoiceTitle == '个人') {
							this.invoice.InvoiceTitle = this.userInfo.value.binding.company.company_name;
						}
						if (this.userInfo.value.binding.customer_type.toLowerCase() == 'vipbiz' || this.userInfo.value.binding.customer_type.toLowerCase() == 'sa') {
							if (this.invoice.InvoiceTitle == '') {
								this.invoice.InvoiceTitle = this.userInfo.value.binding.company.company_name;
							}
							if (this.invoice.Phone == '') {
								this.invoice.Phone = this.userInfo.value.binding.moblie_phone;
							}
							if (this.invoice.BankName == '') {
								this.invoice.BankName = this.userInfo.value.binding.bank.bank_name;
							}
							if (this.invoice.BankNo == '') {
								this.invoice.BankNo = this.userInfo.value.binding.bank.account_number;
							}
							if (this.invoice.Email == '') {
								this.invoice.Email = this.userInfo.value.binding.email;
							}
							if (this.invoice.Address == '上海' || this.invoice.Address == '') {
								this.invoice.Address = this.userInfo.value.binding.company.business_street;
							}
							console.log(this.invoice);
							console.log(this.wechatUserInfo);
						}
						else if (this.userInfo.value.binding.customer_type.toLowerCase() == 'pc') {
							if (this.invoice.Phone == '') {
								this.invoice.Phone = this.userInfo.value.binding.moblie_phone;
							}
						}
						this.showTaxPayerId=true;
					}
					else if(value == '机关事业单位'){
						this.showTaxPayerId=false;
					}
					else {
						if (this.invoice.InvoiceTitle == '个人') {
							this.invoice.InvoiceTitle = '';
						}
						this.showTaxPayerId=true;
					}
				}
			}
		},
		methods: {
			...mapActions([
				'getOMSOrderDetailAction',
				'getOrderInvoiceAction',
				'getInvoiceInfoAction',
				'postOrderInoviceAction',
				'postInvoiceInfoAction',
				'postDeleteInvoiceInfoAction',
				'GetInvoiceDownAction',
				'getOrderChannelAction',
				'getWXOrderDetailAction',
				'getWechatUserInfoAction',
				'GetInvoiceCancelAction',
				'postInvoiceEmailAction',
				'getInvoiceEmailAction',
				'changeOrderAddressAction',
				'postAddAddressAction'
			]),
			async initData() {
				this.from = this.$route.query.from || 'orders';
				let orderno = this.$route.query.orderNo;
				let channel = this.$route.query.channel
				let response = await this.getOMSOrderDetailAction(orderno);
				if (response) {
					var desc = await this.getWXOrderDetailAction(response.originalID);
					if (desc&&desc.delivery[0]) {
						this.deliveryStoreId = desc.delivery[0].DeliveryStoreId
						this.delivery = desc.delivery[0];
						this.shopAddress = desc.delivery[0].Address
						this.deliveryName = desc.delivery[0].DeliveryName
						response.expressUrl = desc.expressUrl
						this.lrptType = desc.delivery[0] && desc.delivery[0].LRPTemplateType
					}
					// if (channel.toLowerCase() == 'wx') {
					channel = await this.getOrderChannelAction({orderid:response.originalID});
					// }
					response.channel = channel
					this.order = response
					if (this.order.userId != this.userInfo.value.binding.register.vip_no) {
						this.$router.push('/orders')
					}
				}
				this.initDataInvoice()
			},
			convertChannel(channel) {
				switch (channel.toLowerCase()) {
					case 'wx':
						return "微信订单"
					case 'wechat':
						return "微信订单"
					case 'oms':
						return "客服门店订单"
					case 'mg':
						return "网络订单"
					case 'myo':
						return 'MyO订单'
					case 'moblieapp':
						return 'MobileApp订单'
					default:
						return channel+'订单'
						break;
				}
			},
			async initDataInvoice() {
				this.CanCancelInvoice = false;

				//canInvoice
				if (this.order.orderStatus == '30' || this.order.channel == "HWG") {
					//订单状态：作废，隐藏审核发票按钮
					this.canInvoice = false;
					return;
				}

				await this.getWechatUserInfoAction();//获取用户数据

				//判断订单是否超过30天
				var now = new Date();
				var DateAdd30 = new Date(now.getFullYear(), now.getMonth()- 1, now.getDate());
				//console.log('DateAdd30');
				//console.log(DateAdd30.getFullYear()+'-'+DateAdd30.getMonth()+'-'+DateAdd30.getDate())
				//var DateAdd30 = new Date();
				var createTime = Date.parse(this.order.createTime.replace(/-/g, '/'));
				// var isEffective = false;
				// if (DateAdd30.getTime() <= createTime) {
				// 	isEffective = true;
				// }
				//var OpenDay=new Date(2018, 11, 16);
				console.log('Valid OpenDay')
				console.log(this.order.createTime)
				var OpenDay=new Date(2018, 11, 16);
				if(createTime<OpenDay.getTime()){
					this.canInvoice = false;
					console.log('Valid OpenDay Close')
					return;
				}
				else{
					console.log('Valid OpenDay Open')
				}

				//查询申请的发票信息
				let orderno = this.$route.query.orderNo;
				let responseOrderInvoice = await this.getOrderInvoiceAction(orderno);
				console.log('发票申请信息');
				console.log(responseOrderInvoice);
				if (responseOrderInvoice) {
					if(responseOrderInvoice.Value2>0){
						this.canInvoice = false;
						return;
					}
					if (responseOrderInvoice.Value.length >= 1) {
						this.invoice = responseOrderInvoice.Value[0];
						this.invoice.CompanyTypeText=this.CompanyTypeText;
						this.InvoiceStatusBtnText = '查看发票详情'

						var createTime = Date.parse(this.invoice.CreateTime.replace(/-/g, '/'));
						
						if (DateAdd30.getTime() <= createTime && this.invoice.InvoiceStatus=='10' && this.invoice.IsCancel==0) {
							this.CanCancelInvoice = true;
						}
						console.log('this.CanCancelInvoice:'+this.CanCancelInvoice)
					}
					else
					{
						this.invoice={
							TaxPayerId: '',
							InvoiceTitle: '个人',
							CompanyTypeText: '个人',
							CompanyType: '03',
							Address: '上海',
							Phone: '',
							BankName: '',
							BankNo: '',
							Email: '',
							InvoiceStatus: '0'
						}
						
						this.InvoiceStatusBtnText='申请开具发票'
					}
				}

				// if (this.InvoiceStatus == 0 && isEffective == false) {
				// 	//未提交过发票信息且超过订单时间30天，隐藏申请发票按钮
				// 	this.canInvoice = false;
				// 	return;
				// }

				if(this.InvoiceStatus == 0){
					//未开票时，查询发票抬头记录历史列表，文本框填充上次申请的记录
					let responseInvoiceInfo = await this.getInvoiceInfoAction(orderno);
					console.log('发票抬头记录历史列表');
					console.log(responseInvoiceInfo);
					if (responseInvoiceInfo) {
						this.invoiceInfo = responseInvoiceInfo;

						//初始化
						if (this.invoiceInfo.length != 0) {
							this.invoiceCompany = this.invoiceInfo.length - 1;

							// this.invoice.CompanyTypeText = '企业';
							// this.invoice.CompanyType = '01';
							this.chooseInvoiceInfo();
						}
					}
					console.log('开票状态');
					console.log(this.InvoiceStatus);
				}
				this.InvoiceLoad = true;//加载完成，显示发票模块
			},
			async cancelInvoice() {
				this.showInvoice = false;
			},
			async submitInvoice() {
				if (this.invoice.InvoiceTitle == '') {
					this.$Modal.info({
						title: '信息',
						content: '请填写发票抬头'
					});
					return;
				}
				if (!/^[\u4e00-\u9fa5a-zA-Z0-9()（）]+$/.test(this.invoice.InvoiceTitle)) {
					this.$Modal.info({
						title: '信息',
						content: '发票抬头不能含有特殊字符，请确认后重新输入'
					});
					return;
				}

				if (this.InvoiceStatus == 0) {
					let orderno = this.$route.query.orderNo;
					//验证纳税人识别号格式，排除个人和机关事业单位的类型
					if (this.invoice.CompanyType != '03' && this.invoice.CompanyType != '02' ) {
						if (this.invoice.TaxPayerId == '') {
							this.$Modal.info({
								title: '信息',
								content: '请填写纳税人识别号'
							});
							return;
						}
						if (this.invoice.TaxPayerId.length != 18 && this.invoice.TaxPayerId.length != 15) {
							//this.confirmInvoice=true;识别号错误允许提交
							this.$Modal.info({
								title: '信息',
								content: '您输入的纳税人识别号有误，请确认后重新输入'
							});
							return;
						}
						// var reg = /^[1-9]+[0-9]*]*$/; //判断字符串是否为数字 ，判断正整数用/^[1-9]+[0-9]*]*$/
						// if (!reg.test(this.invoice.TaxPayerId) && this.invoice.TaxPayerId.length == 15) {
						// 	this.$Modal.info({
						// 		title: '信息',
						// 		content: '您输入的纳税人识别号格式有误，请确认后重新输入'
						// 	});
						// 	return;
						// }
						var re = /^[0-9a-zA-Z]*$/g;  //判断字符串是否为数字和字母组合     //判断正整数 /^[1-9]+[0-9]*]*$/  
						if (!re.test(this.invoice.TaxPayerId)) {
							this.$Modal.info({
								title: '信息',
								content: '您输入的纳税人识别号格式有误，请确认后重新输入'
							});
							return;
						}
					}
					else{
						this.invoice.TaxPayerId='';//机关单位类型不需要纳税识别号
					}
					await this.postInvoice();
				}
				else{
					//查看模式，直接关闭
					this.showInvoice = false;
				}
			},
			async postInvoice() {
				let orderno = this.$route.query.orderNo;
				if (this.invoice.CompanyType != '03') {
					if (this.invoiceInfo.length < 10) {
						let responseInvoiceInfo = await this.postInvoiceInfoAction(this.invoice);
						console.log('保存发票抬头信息');
						console.log(responseInvoiceInfo);
					}
				}
				var argOrderInovice = {
					OrderNo: orderno,
					OriginalID: this.order.originalID,
					OrderDate: this.order.createTime,
					InvoiceAmount: this.order.grandTotal,
					invoice: this.invoice
				}
				let responseOrderInovice = await this.postOrderInoviceAction(argOrderInovice);
				console.log('申请开发票');
				console.log(responseOrderInovice);
				if (responseOrderInovice.Result == 1) {
					//操作成功
					this.$Modal.info({
						title: '信息',
						content: responseOrderInovice.Remark
					});
					this.showInvoice = false;
					this.initDataInvoice()
				}
				else {
					if (responseOrderInovice.Remark) {
						//购货方纳税人识别号格式错误
						if (responseOrderInovice.Remark.indexOf('购货方纳税人识别号格式错误') >= 0) {
							this.$Modal.info({
								title: '信息',
								content: '购货方纳税人识别号格式错误'
							});
						}
						else {
							this.$Modal.info({
								title: '信息',
								content: responseOrderInovice.Remark
							});
						}
					}
					else {
						this.$Modal.info({
							title: '信息',
							content: responseOrderInovice.msg
						});
					}
				}
			},
			async chooseInvoiceInfo() {
				this.invoice.Address = this.invoiceInfo[this.invoiceCompany].Address;
				this.invoice.BankName = this.invoiceInfo[this.invoiceCompany].BankName;
				this.invoice.BankNo = this.invoiceInfo[this.invoiceCompany].BankNo;
				this.invoice.CompanyType = this.invoiceInfo[this.invoiceCompany].CompanyType;
				this.invoice.CompanyTypeText=this.CompanyTypeText;
				this.invoice.Email = this.invoiceInfo[this.invoiceCompany].Email;
				this.invoice.InvoiceTitle = this.invoiceInfo[this.invoiceCompany].InvoiceTitle;
				this.invoice.Phone = this.invoiceInfo[this.invoiceCompany].Phone;
				this.invoice.TaxPayerId = this.invoiceInfo[this.invoiceCompany].TaxPayerId;
				this.invoice.ID = this.invoiceInfo[this.invoiceCompany].ID;
			},
			async deleteInvoiceInfo() {
				let orderno = this.$route.query.orderNo;
				let response = await this.postDeleteInvoiceInfoAction(this.invoiceInfo[this.invoiceCompany].ID);
				console.log(response);
				if (response == 1) {
					//操作成功
					this.$Modal.info({
						title: '信息',
						content: '删除成功！'
					});
					//刷新发票抬头列表
					let responseInvoiceInfo = await this.getInvoiceInfoAction(orderno);
					console.log(responseInvoiceInfo);
					if (responseInvoiceInfo) {
						this.invoiceInfo = responseInvoiceInfo;
					}
				}
				else {
					this.$Modal.info({
						title: '信息',
						content: '删除失败！'
					});
				}

			},
			async InvoinceDown() {
				let orderno = this.$route.query.orderNo;
				let reponse = await this.GetInvoiceDownAction(orderno);
				if (reponse.code == 1) {
					//this.$router.push(reponse.pdfUrl);
					// this.$Modal.info({
					// 	title: '信息',
					// 	content: reponse.pdfUrl
					// });
					this.pdfUrl = reponse.pdfUrl;
					this.showInvoiceLink = true;

					//获取接收发票的邮箱地址
					
					let reponseEmail = await this.getInvoiceEmailAction();
					this.InvoiceEmail=reponseEmail
				}
				else {
					this.$Modal.info({
						title: '信息',
						content: reponse.message
					});
				}
			},
			async InvoinceCancel(){
				var _this=this
				this.$Modal.confirm({
					title: '信息',
					content: '发票作废后仅有一次重开机会，且重开的发票将无法作废，请谨慎操作！<br>请再次确认是否需要取消开具的发票？',
					loading:true,
					onOk: async () => {
						let reponse = await _this.GetInvoiceCancelAction(this.invoice.Id);
						if(reponse==1){
							_this.$Modal.info({
								title: '信息',
								content: '取消成功！'
							});
						}
						else{
							_this.$Modal.info({
								title: '信息',
								content: '取消失败！'
							});
						}
						await _this.initDataInvoice();
						_this.$Modal.remove();
					}
				});
			},
			cancelInvoiceLink() {
				this.showInvoiceLink = false;
			},
			async PostInvoiceEmail(){
				if (this.InvoiceEmail=='') {
					this.$Modal.info({
						title: '信息',
						content: '请输入邮箱地址！'
					});
					return;
				}

				if (!(RE_EMAIL.test(this.InvoiceEmail))) {
					this.$Modal.info({
						title: '信息',
						content: '邮箱格式不正确请重新输入！'
					});
					return;
				}
				var params={RecordId:this.invoice.Id,EmailAddress:this.InvoiceEmail}
				let reponse = await this.postInvoiceEmailAction(params);
				if(reponse){
					this.$Modal.info({
						title: '信息',
						content: '发送成功！'
					});
				}
				this.showInvoiceLink = false;
			},
			async changeAddress(){
            	this.editAddress = {
                    id:0,
                    orderNo:this.order.originalID,
                    name:this.delivery.Name,
                    province_id:parseInt(this.delivery.Province),
                    city_id:parseInt(this.delivery.City),
                    county_id:parseInt(this.delivery.County),
                    town_id:parseInt(this.delivery.Town),
                    street:this.delivery.Street,
                    zip :this.delivery.Zip,
                    moblie_phone:this.delivery.MobliePhone,
                    address_type:2,
                    tag_type:'',
					is_default:false,
					whetherAddress:false
                }
                this.show = true;
            },
			async asyncOK(address){
				let now = new Date()
				let payTime = util.formatDate.dateFromStr(this.order.createTime)
				if (now - payTime > 1800000)  {
					this.show = false;
					this.$Message.error('订单已经发货不可以修改')
					return
				}
                this.addressLoading = true;
                var obj= {
                    Id:address.id,
                    Name:address.name,
                    MobliePhone:address.moblie_phone,
                    Province:address.province_id,
                    City:address.city_id,
                    County:address.county_id,
                    Town:address.town_id,
                    Street:address.street,
                    Zip:address.zip,
                    AddressType:address.address_type,
                    Tags:address.tag_type,
                    IsDefault:address.is_default?1:0,
                    CustomerId:this.userInfo.value.binding.user_id,
                    orderNo:this.order.originalID,
                    omsOrderNo:this.order.orderId,
                    Remark:'',
                };
                obj.Street = obj.Street.replace(/[\s\S]/g,ch=>{
                    let ascii = ch.charCodeAt();
                    if (ascii == 10) return '';
                    if (ascii == 13) return '';
                    if (ascii == 8203) return '';
                    if (ascii == 160) return ' ';
                    return ch;
                });
                let response = await this.changeOrderAddressAction(obj)
                if (response > 0) {
					 if(address.whetherAddress){
                        await this.postAddAddressAction(obj)
                    }
                	this.$Message.success('地址修改成功')
                	await this.initData()
                } else {
                	let message = ''
                    if(response == -1){
                        message = '订单不存在或者订单已经发货或者已经取消不可以修改'
                    } else if(response == -2){
                        message = '订单正在处理中，请稍后修改'
                    } else {
                        message = '地址修改失败'
                    }
                	this.$Message.error(message)
                }
                this.show = false;
                this.addressLoading = false;

            },
		},
	}
</script>

<style lang="scss" scoped>
	@import "@/style/common";
	@import "@/style/mixin";
	.topbar {
		background-color: #f3f4f5;
		a {
			line-height: 40px;
			margin-left: 10.42vw;
			&:hover {
				color: $theme-color;
			}
		}
	}
	.content {
		padding-top: 10px;
		width: 80%;
		margin: auto;
		list-style: none;
		margin-bottom: 50px;
	}
	.order-detail {
		margin-top: 0.5rem;
	}

	.order-left { 
		border-right: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0;
		color: #666;
		background-color: #fbfbfb;
		font-size: 13px;
	}

	.order-info,
	.track h3 {
		border-bottom: 1px solid rgba(0, 0, 0, 0.05);
		line-height: 2;
		font-size: 15px;
		padding-left: 16px;
		background-color: #f5f5f5;
	}

	.track-detail {
		font-size: 15px;
		line-height: 2.5;
		padding-left: 16px;
		padding-top: 10px;
	}

	.products {
		margin-top: 0.5rem;
	}

	.fee {
		line-height: 2;
		margin: 0.5rem auto;
		color: #666;
		font-size: 12px;
	}

	.show-btn {
		margin-left: 0.2rem;
		color:$theme-color;
	}

	.track-list {
		width: 100%;
		border: none;
		height: 350px;
	}

	.Invoice-list {
		line-height: 40px;
		font-size: 14px;
		width: 100%;

	}

	.Invoice-head {
		text-align: right;
		width: 25%;
		padding-right: 15px;
	}

	.Invoice-content {
		/*padding-right:20%*/

	}

	.Invoice-right {
		width: 20%;
	}

	.btn-invoiceDelete {
		float: left;
	}

	.invoice-icon {
		color: red;
	}

	.orderdetail-down {
		font-size: 12px;
		margin-left: 5px;
		color: #BC86C8;
	}

	.orderdetail-downLink {
		font-size: 12px;
		margin-left: 5px;
		color: #ffffff;
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 6px;
		padding-bottom: 6px;

	}
</style>